import ChangeData from "./change_data";

export default [...ChangeData];
